import axios from 'axios';
import { AUTH_BASE_URL } from '@/constants';

export const authService = {
  /**
   * Login user with credentials
   * POST /api/v1/auth/login or /platform/auth/login
   */
  login: async (usernameOrEmail, password, hospitalId) => {
    const response = await axios.post(
      `${AUTH_BASE_URL}/login`,
      {
        username: usernameOrEmail,
        email: usernameOrEmail,
        password,
        hospitalId: hospitalId || '1001',
      },
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true, // Enables HttpOnly refreshToken cookie transmission
      }
    );

    const body = response.data?.data || response.data;
    return {
      user: body.user || body,
      accessToken: body.accessToken || body.token,
    };
  },

  /**
   * Request a fresh access token using the HttpOnly refresh token cookie
   * POST /platform/auth/refresh
   */
  refreshToken: async () => {
    const response = await axios.post(
      `${AUTH_BASE_URL}/refresh`,
      {},
      {
        withCredentials: true, // Sends HttpOnly refreshToken cookie
      }
    );

    const body = response.data?.data || response.data;
    return {
      accessToken: body.accessToken || body.token,
    };
  },

  /**
   * Logout user and invalidate refresh token on server
   * POST /platform/auth/logout
   */
  logout: async () => {
    try {
      await axios.post(
        `${AUTH_BASE_URL}/logout`,
        {},
        {
          withCredentials: true,
        }
      );
    } catch (err) {
      console.warn('Backend logout warning:', err.message);
    }
    return { success: true };
  },

  /**
   * Fetch current authenticated user profile
   * GET /platform/auth/me
   */
  getMe: async (token) => {
    const response = await axios.get(`${AUTH_BASE_URL}/me`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      withCredentials: true,
    });

    return response.data?.data || response.data;
  },
};

export default authService;

